export const UI_MENU_MODAL_ID = 'menu';
